export default "<meu-product-cart-campaign-exchange [campaignID]=\"campaignID\" [public]=\"public\">\r\n</meu-product-cart-campaign-exchange>"